var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0 18 7.6 23.3 0H12.9z",
    fill: "#fec10e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4 4 0 15.9h3.1l1.2-2.4h5.4l1.2 2.4H14L7.6 4H6.4zM7 7.7l1.9 3.8H5.1L7 7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15.8 18 12l-2.4 3.8h-3.2l4.2-6-4-5.7h3l2.5 3.5 2.4-3.5h3l-4 5.7 4.8 6H21zm13.7-5h-8.2a3 3 0 0 0 1 2.2c.6.5 1.3.7 2.3.7 1.2 0 2.1-.3 2.8-1l1 2.1c-1 .8-2.3 1.2-4.2 1.2-1.8 0-3.2-.5-4.2-1.6a6 6 0 0 1-1.5-4.3c0-1.8.5-3.2 1.6-4.4 1-1.2 2.4-1.9 4.1-1.9 1.6 0 3 .5 4 1.5s1.5 2.3 1.5 4c0 .3 0 .8-.2 1.5zm-8-2.1h5.5c-.1-1.7-1-2.6-2.7-2.6-1.6 0-2.5.9-2.9 2.6zm8.7 6.3 1-2.1c.8.6 1.7 1 2.7 1 1 0 1.6-.5 1.6-1.2 0-.5-.3-1-.8-1.4l-1.5-.7c-2-.9-3-2-3-3.5 0-1.1.4-2 1.3-2.5.7-.5 1.6-.8 2.7-.8 1.2 0 2.4.3 3.4.9l-.8 2c-.5-.4-1.4-.7-2.4-.7s-1.4.4-1.4 1.2c0 .4.3.7 1 1.1l1.4.6c2 .8 2.9 2 2.9 3.6a3 3 0 0 1-1.4 2.7c-.8.5-1.8.8-3 .8-.8 0-1.4 0-2-.2a9 9 0 0 1-1.7-.8zm8.6 0 1-2.1c.7.6 1.6 1 2.6 1s1.6-.5 1.6-1.2c0-.5-.3-1-.8-1.4l-1.5-.7c-2-.9-3-2-3-3.5 0-1.1.5-2 1.3-2.5.7-.5 1.7-.8 2.8-.8 1.2 0 2.3.3 3.3.9l-.7 2C50 6.4 49.2 6 48 6c-1 0-1.4.4-1.4 1.2 0 .4.3.7 1 1.1l1.5.6c1.9.8 2.8 2 2.8 3.6a3 3 0 0 1-1.4 2.7c-.8.5-1.8.8-3 .8-.8 0-1.4 0-1.9-.2A9 9 0 0 1 44 15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxess);
export default __webpack_public_path__ + "static/media/axess.2b45030492b9753f5ab83808c6456a75.svg";
export { ForwardRef as ReactComponent };